import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { IconAlertComponent, IconComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-cart-order-item-option-item',
  templateUrl: './cart-order-item-option-item.component.html',
  styleUrls: ['./cart-order-item-option-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconAlertComponent, IconComponent, TagComponent],
})
export class CartOrderItemOptionItemComponent {
  readonly quantity = input.required<number>();
  readonly name = input.required<string>();
  readonly formattedTotal = input<string | undefined>(undefined);
  readonly stockWarningLabel = input<string | undefined>(undefined);
}
